export const consumerFloorplans = {
  '--GW-HEADER-HEIGHT': '4.25rem',
  '--GW-SUBHEADER-HEIGHT': '3rem',
  '--GW-CONTEXT-SWITCHER-HEIGHT': '2.5rem',
  '--GW-HEADER-BUTTON-HEIGHT': '2.5rem',
  '--GW-HEADER-SEARCH-HEIGHT': '2.5rem',
  '--GW-BURGER-MENU-BUTTON-SIZE': '2.5rem'
};